/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */
import { Button } from "@mui/material";

const CustomButton = ({
  disabled,
  size,
  fullWidth=false,
  type,
  variant,
  onClick,
  style,
  body,

  // startIcon
}) => {
  return (
    // eslint-disable-next-line react/react-in-jsx-scope
    <Button
      disabled={disabled}
      fullWidth={fullWidth}
      size={size}
      type={type}
      variant={variant}
      onClick={onClick}
      sx={style}
      // startIcon={startIcon}
    >
      {body}
    </Button>
  );
};

export default CustomButton;
